// ---------------------------------------------------------------------------
// The browser side of HELP. Run 76.
//
// ONE ENDPOINT, AND IT SERVES A VOCABULARY RATHER THAN TENANT DATA.
// `app.permission`, `app.org_role` and `app.role_permission` are platform
// tables with no `org_id` and no row-level security — they are the same 54
// sentences for every organisation. So this is a reference call in the sense
// `reference.ts` already means it, and it is cached by the screen for the life
// of the page rather than re-fetched per section.
//
// ★ THE SCREEN MUST WORK WITHOUT IT, AND THAT IS A DEPLOY-ORDER DECISION RATHER
// THAN DEFENSIVENESS. The app and the Worker ship separately, so there is a
// window where this page exists and the route does not. A help screen that
// breaks in exactly the window somebody is most likely to be confused is worse
// than one that answers the question in permission ids instead of labels — so
// the labels are an ENRICHMENT and never a precondition.
// ---------------------------------------------------------------------------
import { read } from "./console";

export type PermissionRef = {
  id: string;
  label: string;
  description: string;
};

export type RoleRef = {
  id: string;
  label: string;
  description: string;
  is_external: boolean;
  is_platform: boolean;
  /** Permission ids, sorted. */
  permissions: string[];
};

export type ReferenceReply = {
  permissions?: PermissionRef[];
  roles?: RoleRef[];
  error?: { message?: string };
};

export const helpApi = {
  reference: (base: string) => read(base, "/v1/reference/permissions"),
};
